<homey-lotteries-dialog-content
  singleTitle="New eligible lotteries"
  multipleTitle="New eligible lotteries"
  singleDescription="Due to the changes in your profile, you're now eligible for the following lotteries:"
  multipleDescription="Due to the changes in your profile, you're now eligible for the following lotteries:"
  [notification]="data()" [closeButton]="closeButton()">
  <ng-template lotteryDialogListItem let-lottery>
    <homey-open-lottery-list-item [noNegativeMargin]="true" [openInPopup]="true"
                                  [lottery]="lottery"></homey-open-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>


